import { EditOutlined } from '@ant-design/icons';
import { Button, Input, Table } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import IDrawerDTO from '../../../dtos/IDrawerDTO';
import ILocationDTO from '../../../dtos/ILocationDTO';
import IMaterialDTO from '../../../dtos/IMaterialDTO';
import IMaterialType from '../../../dtos/IMaterialTypeDTO';
import IMeasurementUnitDTO from '../../../dtos/IMeasurementUnitDTO';
import { useApi } from '../../../hooks/api';
import { Actions, Container } from './styles';

const columns = [
  {
    title: 'Código',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: 'Descrição',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Un. Medida',
    dataIndex: 'measurementUnit',
    key: 'measurementUnit',
    render: (measurementUnit: IMeasurementUnitDTO) => measurementUnit.name,
  },
  {
    title: 'Tipo',
    dataIndex: 'materialType',
    key: 'materialType',
    render: (materialType: IMaterialType) => materialType.name,
  },
  {
    title: 'Quantidade',
    dataIndex: 'quantity',
    key: 'quantity',
  },
  {
    title: 'Localização',
    dataIndex: 'location',
    key: 'location',
    render: (location: ILocationDTO) => location?.description,
  },
  {
    title: 'Gaveta',
    dataIndex: 'drawer',
    key: 'drawer',
    render: (drawer: IDrawerDTO) => drawer?.name,
  },
  {
    title: 'Compartimento',
    dataIndex: 'compartment',
    key: 'compartment',
  },
];

const ListMaterials: React.FC = () => {
  const { api } = useApi();
  const history = useHistory();
  const [materials, setMaterials] = useState<IMaterialDTO[]>();
  const [search, setSearch] = useState('');
  const [xCount, setXCount] = useState(0);

  const listMaterials = useCallback(
    async (skip = 0) => {
      const response = await api.get<IMaterialDTO[]>(
        `materials?search=${search}&nullableLocations=true&skip=${skip}`,
      );

      const data = response.data.map((material) => ({
        key: material.id,
        ...material,
      }));

      setXCount(Number(response.headers['x-count']) || 0);
      setMaterials(data);
    },
    [api, search],
  );

  useEffect(() => {
    listMaterials();
  }, [listMaterials]);

  const handleNavigate = (to: string): void => {
    history.push(to);
  };

  return (
    <Container>
      <h1>Materiais</h1>
      <Input.Search
        placeholder="Buscar por código ou descrição"
        onSearch={(value) => setSearch(value)}
        style={{ width: 600, marginBottom: 20 }}
      />
      <h4>Total {xCount}</h4>

      <Table
        columns={[
          ...columns,
          {
            title: '#',
            dataIndex: '#',
            key: '#',
            render: (_: string, record: IMaterialDTO) => {
              return (
                <Actions>
                  <Button
                    title="Editar"
                    type="primary"
                    onClick={() => handleNavigate(`/materiais/${record.id}`)}
                  >
                    <EditOutlined />
                  </Button>
                  {/* <Button danger title="Excluir" disabled>
                    <DeleteFilled />
                  </Button> */}
                </Actions>
              );
            },
          },
        ]}
        dataSource={materials}
        pagination={{
          total: xCount,
          onChange: (page) => listMaterials((page - 1) * 10),
          pageSizeOptions: [10],
        }}
      />
    </Container>
  );
};

export default ListMaterials;
